
export class Customer {
  reference: string;
  account: any;
  firstname: string;
  lastname: string;
  phone: string;
  email: string;
  address: string;
  status: string;
  username: string;
  role: any;
  plainPassword: string;
  picture: any;
  country: any;
  city: any;
  idType: string;
  idNumber: string;
  lastConnexion: string;
  lastChangePassword: string;
  notificationType: string;
  platform: any;
  cardExpiration: any;
  timezoneOffset: number;
  birthDate:any;
  doubleAuthenticationRequired:boolean;
  sex:string
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/customer/customer.model.ts